/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {LoadingSpinnerModule} from '../../shared/loading/loading-spinner/loading-spinner.module';
import {BundlesMainPageComponent} from './bundles-main-page.component';
import {ToggleButtonModule} from '../../shared/toggle-button/toggle-button.module';
import {TabsModule} from '../../shared/tabs/tabs.module';
import {PeriodsTableModule} from '../periods-table/periods-table.module';
import {BundleSettlementsTableModule} from '../bundle-settlements-table/bundle-settlements-table.module';
import {SegmentedButtonModule} from '../../shared/segemented-button/segmented-button.module';
import {CommonModule} from '@angular/common';
import {PeriodBundlesTableModule} from '../period-bundles-table/period-bundles-table.module';
import {BundlesViewModule} from '../bundles-view/bundles-view.module';
import {PaginationModule} from '../../shared/pagination/pagination.module';
import {SettlementsViewModule} from '../settlements-view/settlements-view.module';
import {GlobalSearchCriteriaModule} from '../../shared/global-search-criteria/global-search-criteria.module';
import {BundlingSettingsModule} from '../bundling-settings/bundling-settings.module';
import {SwitchButtonModule} from '../../shared/switch-button/switch-button.module';
import {TooltipModule} from '../../shared/tooltip/tooltip.module';
import {BundlesPipesModule} from '../shared/pipes/bundles-pipes.module';
import {PipesModule} from '../../shared/pipes/pipes.module';

@NgModule({
    imports: [
        LoadingSpinnerModule,
        ToggleButtonModule,
        BundleSettlementsTableModule,
        TabsModule,
        PeriodsTableModule,
        SegmentedButtonModule,
        CommonModule,
        PeriodBundlesTableModule,
        PaginationModule,
        BundlesViewModule,
        SettlementsViewModule,
        GlobalSearchCriteriaModule,
        BundlingSettingsModule,
        SwitchButtonModule,
        TooltipModule,
        BundlesPipesModule,
        PipesModule
    ],
    declarations: [BundlesMainPageComponent],
    exports: [BundlesMainPageComponent]
})
export class BundlesMainPageModule {
}
